/* Shared product-page behaviours; native Shopify cart submission remains untouched. */
if (!customElements.get('mf-purchase-summary')) {
  customElements.define('mf-purchase-summary', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.formElement = document.getElementById(this.getAttribute('form'));
      this.unitPrice = Number(this.dataset.unitPrice);
      const options = { signal: this.controller.signal };
      const updateQuantity = event => {
        if (event.target?.name === 'quantity') this.updateTotal();
      };
      this.formElement?.addEventListener('input', updateQuantity, options);
      this.formElement?.addEventListener('change', updateQuantity, options);
      this.formElement?.addEventListener('variant:change', event => {
        this.unitPrice = Number(event.detail.variant?.price);
        this.updateTotal();
      }, options);
      this.updateTotal();
    }
    disconnectedCallback() { this.controller?.abort(); }
    updateTotal() {
      const input = this.querySelector('input[name="quantity"]');
      const quantity = Number(input?.value || input?.min || 1);
      const output = this.querySelector('[data-mf-total]');
      if (!output) return;
      if (!Number.isFinite(this.unitPrice)) { output.textContent = 'Unavailable'; return; }
      if (!Number.isInteger(quantity) || quantity < 1) { output.textContent = 'Choose quantity'; return; }
      output.textContent = new Intl.NumberFormat(this.dataset.locale || 'en-GB', {
        style: 'currency', currency: this.dataset.currency || 'GBP'
      }).format(Math.round(this.unitPrice * quantity) / 100);
    }
  });
}
if (!document.documentElement.hasAttribute('data-mf-product-links')) {
  document.documentElement.setAttribute('data-mf-product-links', '');
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-mf-details-link]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!(target instanceof HTMLElement)) return;
    event.preventDefault();
    target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    target.focus({ preventScroll: true });
  });
}

/* Optional property-to-image links: choices stay order properties, never new SKUs.
   Normal entry stays on the hero; images change only after buyer interaction. */
if (!document.documentElement.hasAttribute('data-mf-property-media-links')) {
  document.documentElement.setAttribute('data-mf-property-media-links', '');
  const groupsFor = form => [...document.querySelectorAll('[data-mf-property-media]')]
    .filter(group => group.dataset.mfFormId === form?.getAttribute('id'));
  const selectedVariant = form => {
    const picker = [...document.querySelectorAll('variant-picker')]
      .find(element => element.getAttribute('form-id') === form?.getAttribute('id'));
    try { return JSON.parse(picker?.querySelector('script[data-variant]')?.textContent || '{}'); }
    catch { return {}; }
  };
  const propertyMedia = (group, variant) => {
    const index = Number(group.dataset.mfOptionIndex);
    const value = variant?.options?.[index] ?? variant?.['option' + (index + 1)];
    if (value !== group.dataset.mfOptionValue) return null;
    return group.querySelector('input:checked[data-mf-media-id]')?.dataset.mfMediaId || null;
  };
  const showMedia = (form, mediaId) => {
    if (!mediaId) return;
    const gallery = [...document.querySelectorAll('product-gallery')]
      .find(element => element.getAttribute('form') === form?.getAttribute('id'));
    const carousel = gallery?.querySelector('.product-gallery__carousel');
    if (!carousel) return;
    const cells = [...carousel.querySelectorAll('[data-media-id]')].filter(cell => !cell.hidden);
    const index = cells.findIndex(cell => cell.dataset.mediaId === String(mediaId));
    if (index >= 0 && typeof carousel.select === 'function') carousel.select(index, { instant: true });
  };
  document.addEventListener('change', event => {
    const input = event.target.closest?.('[data-mf-media-id]');
    const group = input?.closest('[data-mf-property-media]');
    if (!group || !input.checked) return;
    const form = document.getElementById(group.dataset.mfFormId);
    showMedia(form, propertyMedia(group, selectedVariant(form)));
  });
  document.addEventListener('variant:change', event => {
    const form = event.target;
    const groups = groupsFor(form);
    if (!groups.length || !event.detail.variant?.id) return;
    const override = groups.map(group => propertyMedia(group, event.detail.variant)).find(Boolean);
    showMedia(form, override || event.detail.variant.featured_media?.id);
  });
}
